import { render, staticRenderFns } from "./ThemeSetting.vue?vue&type=template&id=1cca8b8f&scoped=true&"
import script from "./ThemeSetting.vue?vue&type=script&lang=js&"
export * from "./ThemeSetting.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSetting.vue?vue&type=style&index=0&id=1cca8b8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cca8b8f",
  null
  
)

export default component.exports